import { useLocation } from 'react-use';

import Container from 'quarks/Container';
import Flex from 'quarks/Flex';
import Image from 'quarks/Image';
import Link from 'quarks/Link';
import Text from 'quarks/Text';
import type { BasicProps } from 'quarks/interpolations/basic';

import type { ContentfulElementMenu } from 'graphqlTypes';
import type { FC } from 'react';

export interface SubMenuProps extends BasicProps {
  menu?: ContentfulElementMenu;
  setIsMobileNavOpen?: () => void;
  setOpenMenu?: () => void;
}

const SubMenu: FC<SubMenuProps> = ({ menu, setIsMobileNavOpen, setOpenMenu, ...props }) => {
  const { pathname } = useLocation();

  const handleClick = () => {
    if (menu?.url?.includes(pathname)) {
      setIsMobileNavOpen && setIsMobileNavOpen(false);
      setOpenMenu && setOpenMenu(-1);
    }
  };

  return (
    <Container as="li" key={menu?.id} width="100%" {...props} css={{ listStyle: 'none' }}>
      {menu?.heading && (
        <>
          {menu?.url ? (
            <Link
              href={menu?.url || ''}
              textColor="gray-900"
              textStyle="textXs"
              fontWeight="semiBold"
              textDecoration="none"
              textAlign="left"
              onClick={handleClick}
              css={`
                border-radius: 5px;
                display: flex;
                font-size: 14px;
                margin-bottom: 8px;
                padding: 10px;

                &:hover {
                  background: rgba(40, 40, 40, 0.05);
                  cursor: pointer;
                }
              `}
            >
              <Flex display="flex" alignItems="center">
                {menu?.icon && (
                  <Image
                    image={menu?.icon}
                    alt={menu?.icon?.title || ''}
                    width="24px"
                    height="24px"
                    marginRight={10}
                    data-testid="menu-icon-1"
                  />
                )}
                {menu.heading}
              </Flex>
            </Link>
          ) : (
            <>
              {menu?.icon && (
                <Image
                  image={menu?.icon}
                  alt={menu?.icon?.title || ''}
                  width="24px"
                  height="24px"
                  marginRight={10}
                  data-testid="menu-icon-2"
                />
              )}
              <Text textColor="gray-900" textStyle="textXs" fontWeight="semiBold">
                {menu.heading}
              </Text>
            </>
          )}
        </>
      )}
    </Container>
  );
};

export default SubMenu;
